<div class="modal-dialog change-email-dialog-container">
	<div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
		<form (ngSubmit)="submit(form)" [formGroup]="form">
			<div class="goreact-modal-header">
				<h4 class="modal-title" [id]="dialogTitleId" translate="modal-change-email_change-email"></h4>
				<button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close'| translate">
					<i class="ficon-app-x"></i>
				</button>
			</div>
			<div class="goreact-modal-body" #content>
				<mat-form-field appearance="outline" class="new-email">
					<mat-label translate="modal-change-email_new-email"></mat-label>
					<input type="email" matInput formControlName="newEmail" class="fullstory-ignore" />
					@if (form.controls.newEmail.hasError('required')) {
						<mat-error translate="common-validation_email-required"></mat-error>
					}
					@if (form.controls.newEmail.hasError('email')) {
						<mat-error translate="common-validation_email"></mat-error>
					}
				</mat-form-field>

				<mat-form-field appearance="outline" class="password" goPasswordVisibilityToggle>
					<mat-label translate="modal-change-email_current-password"></mat-label>
					<input type="password" matInput formControlName="password" class="fullstory-ignore password-input" />
					@if (form.controls.password.hasError('required')) {
						<mat-error translate="modal-change-email_error-password"></mat-error>
					}
					@if (form.controls.password.hasError('incorrect')) {
						<mat-error translate="common-validation_incorrect-password"></mat-error>
					}
				</mat-form-field>
			</div>
			<div class="goreact-modal-footer">
				@if (error) {
					<span class="error-text">{{ error }}</span>
				}
				<button
					type="button"
					class="cancel-btn tertiary-btn"
					(click)="close()"
					[attr.aria-label]="'common_cancel'| translate">
					{{'common_cancel' | translate}}
				</button>
				<button
					type="submit"
					class="primary-btn submit-btn"
					[attr.aria-label]="'modal-change-email_change-email' | translate"
					[disabled]="(loading$ | async)"
					[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">
					@if (loading$ | async) {
						<i class="ficon-spinner ficon-spin"></i>
					}
					<span translate="modal-change-email_change-email"></span>
				</button>
			</div>
		</form>
	</div>
</div>
